import { initialData, ticketStatus } from "./constants";

export function ticketsDataDTO(tickets: any) {
  if (!tickets || !Array.isArray(tickets)) {
    return initialData;
  }

  const ticketsDataObj = tickets.reduce((obj: any, state: any) => {
    const openTicketIds = obj?.open || [];
    const inProgressTicketIds = obj?.["in-progress"] || [];
    const closedTicketsIds = obj?.["closed"] || [];

    function getPreviousIds() {
      if (state.status === "open") {
        return openTicketIds;
      }
      if (state.status === "progress") {
        return inProgressTicketIds;
      }

      if (state.status === "done") {
        return closedTicketsIds;
      }
      return "";
    }

    obj = {
      ...obj,
      tickets: {
        ...obj?.tickets,
        [state["ticket_id"]]: state,
      },
      [ticketStatus[state?.status]]: [...getPreviousIds(), state?.ticket_id],
    };

    return obj;
  }, {});

  return {
    ...initialData,
    tickets: ticketsDataObj?.tickets,
    columns: {
      ...initialData?.columns,
      open: {
        ...initialData?.columns?.open,
        ticketIds: ticketsDataObj?.open,
      },
      "in-progress": {
        ...initialData?.columns?.["in-progress"],
        ticketIds: ticketsDataObj?.["in-progress"],
      },
      closed: {
        ...initialData?.columns?.closed,
        ticketIds: ticketsDataObj?.closed,
      },
    },
  };
}
